// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3kG7g","btn":"styles_btn__3uTqn"};